import { cn } from "@/lib/utils";
import { motion, stagger, useAnimate, useInView } from "framer-motion";
import { useEffect } from "react";

export const TypewriterEffect = ({
  words,
  className,
  cursorClassName,
}) => {
  const wordsArray = words.map((word) => {
    return {
      ...word,
      text: word.text.split(""),
    };
  });

  const [scope, animate] = useAnimate();
  const isInView = useInView(scope);
  
  useEffect(() => {
    if (isInView) {
      animate(
        ".typewriter-char",
        {
          opacity: 1,
        },
        {
          duration: 0.05,
          delay: stagger(0.1),
          ease: "linear",
        }
      );
    }
  }, [isInView, animate]);

  const renderWords = () => {
    return (
      <motion.span ref={scope} className="d-inline" style={{ whiteSpace: "nowrap" }}>
        {wordsArray.map((word, idx) => {
          return (
            <span key={`word-${idx}`} className="d-inline-block">
              {word.text.map((char, index) => (
                <motion.span
                  initial={{ opacity: 0 }}
                  key={`char-${idx}-${index}`}
                  className={cn(
                    `typewriter-char`,
                    word.className
                  )}
                  style={{ display: "inline-block" }}
                >
                  {char}
                </motion.span>
              ))}
              &nbsp;
            </span>
          );
        })}
      </motion.span>
    );
  };
  
  return (
    <div
      className={cn(
        "typewriter-container",
        className
      )}
    >
      {renderWords()}
      <motion.span
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          duration: 0.8,
          repeat: Infinity,
          repeatType: "reverse",
        }}
        className={cn(
          "typewriter-cursor",
          cursorClassName
        )}
      ></motion.span>
    </div>
  );
};

export const TypewriterEffectSmooth = ({
  words,
  className,
  cursorClassName,
}) => {
  const wordsArray = words.map((word) => {
    return {
      ...word,
      text: word.text.split(""),
    };
  });
  
  const renderWords = () => {
    return (
      <div>
        {wordsArray.map((word, idx) => {
          return (
            <div key={`word-${idx}`} className="inline-block">
              {word.text.map((char, index) => (
                <span
                  key={`char-${index}`}
                  className={cn(`typewriter-char-smooth`, word.className)}
                >
                  {char}
                </span>
              ))}
              &nbsp;
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className={cn("typewriter-smooth-container", className)}>
      <motion.div
        className="typewriter-smooth-wrapper"
        initial={{
          width: "0%",
        }}
        whileInView={{
          width: "fit-content",
        }}
        transition={{
          duration: 2,
          ease: "linear",
          delay: 1,
        }}
      >
        <div
          className="typewriter-smooth-text"
          style={{
            whiteSpace: "nowrap",
          }}
        >
          {renderWords()}{" "}
        </div>{" "}
      </motion.div>
      <motion.span
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          duration: 0.8,
          repeat: Infinity,
          repeatType: "reverse",
        }}
        className={cn(
          "typewriter-cursor-smooth",
          cursorClassName
        )}
      ></motion.span>
    </div>
  );
};
